import { useState, useCallback } from 'react'

export const useConversationalMode = (initialState: boolean = false) => {
  const [isActive, setIsActive] = useState(initialState)

  const activate = useCallback(() => {
    setIsActive(true)
  }, [])

  const deactivate = useCallback(() => {
    setIsActive(false)
  }, [])

  const toggle = useCallback(() => {
    setIsActive(prev => !prev)
  }, [])

  return {
    isActive,
    activate,
    deactivate,
    toggle
  }
}

